module.exports = __webpack_public_path__ + "img/upgrade_2_selector_highlight.b3595e95.png";